import { render, staticRenderFns } from "./WidgetContainer.vue?vue&type=template&id=dd6cb5d6&"
import script from "./WidgetContainer.vue?vue&type=script&lang=ts&"
export * from "./WidgetContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports